module.exports = __webpack_public_path__ + "static/media/hdi-vest.74776d48.svg";